import styled from 'styled-components'
import { Modal } from 'react-bootstrap'
import {
  meetingRoomModalHeaderStyles,
  createMeetingRoomModalDialogStyles,
  MEETING_ROOM_MODAL_WIDTH,
} from '../../shared/meetingRoomModalStyles'

const FIELD_MAX_WIDTH = '768px'
const FIELD_COLUMN_WIDTH = '372px'
export const ACCESS_TIME_ICON_URL = '/icon/access-time.svg'

export const StyledModal = styled(Modal)`
  ${createMeetingRoomModalDialogStyles(MEETING_ROOM_MODAL_WIDTH)}

  ${meetingRoomModalHeaderStyles}

  .modal-body {
    padding: 24px 24px 16px;
    min-height: 0;
    overflow-y: auto;
  }
`

export const FormFieldsContainer = styled.div`
  max-width: ${FIELD_MAX_WIDTH};
  width: 100%;

  .form-control,
  .form-select {
    height: 38px;
    padding: 8px;
    font-size: 16px;
    font-weight: 400;
    line-height: 140%;
    color: var(--grey);
  }

  .form-select,
  .form-control:not([readonly]) {
    border: 1px solid var(--grey);
  }

  .form-control:focus,
  .form-select:focus {
    box-shadow: none;
    border-color: var(--primary);
  }

  .form-control[readonly] {
    color: var(--input-color) !important;
    background-color: var(--white);
    border: 1px solid var(--input-border-muted);
  }
`

export const Section = styled.div`
  &:not(:last-of-type) {
    margin-bottom: 24px;
  }

  &:not(:first-of-type) {
    border-top: 1px solid var(--border);
    padding-top: 24px;
  }
`

export const SectionTitle = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: var(--grey);
  margin: 0 0 16px;
`

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`

export const FieldRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const FieldRowGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, ${FIELD_COLUMN_WIDTH}));
  gap: 24px;
  width: 100%;
`

export const FieldLabel = styled.label`
  font-size: 14px;
  font-weight: 700;
  color: var(--grey);
  line-height: 140%;
  margin: 0;
`

export const TimeInputWrapper = styled.div<{ $readonly?: boolean }>`
  position: relative;
  width: 100%;
  max-width: ${FIELD_COLUMN_WIDTH};

  .time-input-icon {
    position: absolute;
    left: 8px;
    top: 50%;
    transform: translateY(-50%);
    width: 24px;
    height: 24px;
    pointer-events: none;
    z-index: 1;
    opacity: ${({ $readonly }) => ($readonly ? 0.55 : 1)};
  }

  .form-control {
    padding-left: calc(8px + 24px + 8px);
  }

  .form-control::-webkit-calendar-picker-indicator {
    opacity: 0;
    position: absolute;
    right: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
`

export const FooterActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  width: 100%;
  margin-top: 14px;
`

export const ConfirmButton = styled.button`
  height: 32px;
  min-width: 156px;
  padding: 0 16px;
  background: var(--primary);
  color: var(--white);
  font-size: 14px;
  font-weight: 700;
  border: none;
  border-radius: 4px;
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`

export const CancelButton = styled.button`
  height: 32px;
  min-width: 156px;
  padding: 0 16px;
  background: var(--white);
  color: var(--primary);
  font-size: 14px;
  font-weight: 700;
  border: 2px solid var(--primary);
  border-radius: 4px;
  cursor: pointer;
`
